import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectSpecialistRoleToWork } from '../../app/actions/userRoleActions';
import useActiveSpecialistRole, { getActiveSpecialistRoleLabel } from '../../app/hooks/useActiveSpecialistRole';
import { getRoleDisplayLabel } from '../../app/helpers/specialistRoleModuleHelper';

const SpecialistRoleSwitcher = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    flowEngineEnabled,
    availableRoles,
    selectedRole,
    showSwitcher,
    showActiveRoleLabel
  } = useActiveSpecialistRole();

  if (!flowEngineEnabled || !showActiveRoleLabel) {
    return null;
  }

  const handleChangeRole = (event) => {
    const roleId = Number(event.target.value);
    const role = availableRoles.find((item) => Number(item.id) === roleId);

    if (role) {
      dispatch(selectSpecialistRoleToWork(role));
    }
  };

  return (
    <div
      className="d-flex align-items-center gap-2 flex-wrap"
      style={{ paddingLeft: '20px', paddingRight: '20px', color: 'white' }}
    >
      <span>
        <strong>{t('specialist.selection.role.activeLabel', 'Rol activo:')}</strong>{' '}
        {selectedRole?.roleKey === 'feeder'
          ? t('specialist.selection.roles.feeder.badge', 'Alimentador')
          : getActiveSpecialistRoleLabel(selectedRole, t)}
      </span>

      {showSwitcher && (
        <select
          className="form-select form-select-sm"
          style={{ width: 'auto', minWidth: '180px' }}
          value={selectedRole?.id || ''}
          onChange={handleChangeRole}
          aria-label={t('specialist.selection.role.switchLabel', 'Cambiar rol especialista')}
        >
          {availableRoles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.roleKey === 'feeder'
                ? t('specialist.selection.roles.feeder.badge', 'Alimentador')
                : getRoleDisplayLabel(role.name, t)}
            </option>
          ))}
        </select>
      )}

      {showSwitcher && (
        <Link
          to="/specialist-role-selection"
          className="text-white text-decoration-underline small"
        >
          {t('specialist.selection.role.manageLink', 'Gestionar roles')}
        </Link>
      )}
    </div>
  );
};

export default SpecialistRoleSwitcher;
